export default __webpack_public_path__ + "static/FritzphoneC4_03-047ba7b2f89996a2c5daadd444062380.webp";